import { render, staticRenderFns } from "./rate-pricing.vue?vue&type=template&id=556165fe&scoped=true&"
import script from "./rate-pricing.vue?vue&type=script&lang=js&"
export * from "./rate-pricing.vue?vue&type=script&lang=js&"
import style0 from "./rate-pricing.vue?vue&type=style&index=0&id=556165fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556165fe",
  null
  
)

export default component.exports